import {
  CatalogKindExploreContent,
  ExploreLayout,
} from '@backstage-community/plugin-explore';
import React from 'react';

export const ExplorePage = () => {
  return (
    <ExploreLayout
      title="Explore the ecosystem"
      subtitle="Browse your ecosystem"
    >
      <ExploreLayout.Route path="domains" title="Domains">
        <CatalogKindExploreContent kind="domain" />
      </ExploreLayout.Route>
    </ExploreLayout>
  );
};

export const explorePage = <ExplorePage />;
